<template>
    <div class="therefuel">
        <div class="head">
            <span class="left">No.{{site_name}}</span>
            <span  class="iconfont icon-you"></span>
        </div>
        <div class="content">
            <h3>1号枪</h3>
            <div class="text">
                <span>{{state_text}}</span>
            </div>
        </div>
        <div class="bts">
            <span class="selected" @click="launch" >{{comestate}}</span>
        </div>
    </div>
</template>
    
    <script>
        import common from "../common";
        import { MessageBox } from 'mint-ui';
        export default {
            name: "therefuel",
            data(){
                return{
                    site_name:"",
                    comestate:"启动加油",
                    devicemac:"",
                    remainingnum_:"",
                    state_text:"准备就绪，请确保车辆停在加油机旁，以免错加，造成不必要的损失!",//状态描述
                    state:"",//加油机的状态
                    orderid_:"",
                    timer1:"",
                    websock: null,
                    token:"",
                    controls:false,//是否授权
                    ping_time:""
                }
            },
            methods:{
                launch(){
                    let obj={type:"device",data:this.devicemac,orderid:this.orderid_};
                    let JSONdata=JSON.stringify(obj);
                    this.websock.send(JSONdata);
                },
                initWebSocket(){ //初始化weosocket
                    //ws地址
                    const wsuri = 'ws://114.215.156.150:8181';
                    this.websock = new WebSocket(wsuri);
                    this.websock.onmessage = this.websocketmessage;
                    this.websock.onclose=this.websocketonclose;
                    this.websock.onopen=this.websocketonopen;
                },
                websocketmessage(agentData){//数据接收
                    let data=JSON.parse(agentData.data);
                    console.log(data);
                    if(data.type=="0FH"){
                        if(data.detail.status=="00"||data.detail.status=="01"){
                            this.controls=true;
                            this.state_text="请提枪加油,如果无法加油,请再次点击启动按钮";
                        }
                        if(data.detail.status=="03"&&this.controls){
                            let obj1={type:"undevice",data:this.devicemac};
                            let JSONdata1=JSON.stringify(obj1);
                            this.websock.send(JSONdata1);
                            window.clearInterval(this.timer1);
                            this.state_text="加油完成"+data.detail.num+"升";
                            let querystring = require('querystring');
                            this.$api.post("wx/payAutoOrder",
                                querystring.stringify({
                                    token:this.token,
                                    order_id:this.orderid_,
                                    num:data.detail.num
                                })                                
                            ).then(data=>{
                                this.$router.replace({ path: '/orderDetail/'+this.orderid_});
                            }).catch(err=>{
                                this.$router.replace({ path: '/orderDetail/'+this.orderid_});
                            })
                        }
                    }else{
                        this.state_text=data.data;
                        // common.toast(data.data); 
                    }
                    if(data.type=="msg"&data.status==1){
                        let querystring = require('querystring');
                        this.$api.post("wx/startAutoAdd ",
                            querystring.stringify({
                                token:this.token,
                                device_mac:this.devicemac,
                                surplus:this.remainingnum_,
                                client:data.client
                            })
                        ).then((data,option)=>{
                            this.timer1=setInterval(()=>{
                                this.$api.post("wx/checkDeviceStatus ",
                                    querystring.stringify({
                                        token:this.token,
                                        device_mac:this.devicemac
                                    })
                                ).then((data)=>{
                                    console.log(data);
                                }).catch((err)=>{
                                    console.log(err);
                                })
                            },2000)
                        })
                    }
                },
                websocketonclose(){
                    console.log("已关闭");
                    clearInterval(this.ping_time);
                },
                websocketonopen(){
                    // this.ping_time=setInterval(()=>{
                    //     this.websock.send("ping");
                    // },1000)
                    console.log("打开");
                }
            },
            created() {
                //读取登录状态：localStorage 优先，cookie 兜底
                let userInfo=common.getUserInfo();
                if(userInfo){
                    this.token=userInfo.token;
                }else{
                    this.$router.replace({ name: 'login'});
                }
                this.initWebSocket();
            },
            mounted() {
                let facility_data=JSON.parse(this.$router.currentRoute.params.facility);
                this.devicemac=facility_data.device_mac;
                this.site_name=facility_data.site_name;
                this.remainingnum_=facility_data.total_number;
                this.orderid_=facility_data.order_id;
            },
            destroyed(){
                this.websock.close();
                // let obj={type:"stop",data:this.devicemac};
                // let JSONdata=JSON.stringify(obj);
                // this.websock.send(JSONdata);
            }
    
        }
</script>

<style>
    .therefuel{
        width: 100vw;
        height: 100vh;
        background: #f5f5f5;
    }
    .therefuel>.head{
        height: 100px;
        background: white;
        display: -webkit-flex;
        align-items: center;
        padding-left: 30px;
        font-size: 30px;
    }
    .therefuel .icon-you{
        font-size: 40px;
    }
    .therefuel .content{
        width: 500px;
        height: 400px;
        border: 2px solid black;
        border-radius: 20px;
        margin: 50px auto;
        padding: 40px;
    }
    .therefuel .content h3{
        font-size: 60px;
        margin: 0;
        padding: 0;
        color: red;
    }
    .therefuel .content .text{
        font-size: 45px;
    }
    .therefuel .bts{
        margin: 100px auto;
        width: 580px;
        height: 100px;
        border: 2px solid #0ebfb0;
        display: -webkit-flex;
        border-radius: 0.2rem;
    }
    .therefuel .bts>span{
        flex: 1;
        text-align: center;
        line-height: 100px;
        font-size: 0.6rem;
        color: white;
    }
    .therefuel .bts>.selected{
        background: #0ebfb0;
    }
    .addClass{
        padding: 20px !important;
    }
    .addClass>span{
        padding-top: 0 !important;
    }
</style>
    


// WEBPACK FOOTER //
// src/selfhelp/therefuel.vue